import React from 'react'
import { SvgIcon } from '@mui/material'

export const StopIcon = props => (
  <SvgIcon
    viewBox="0 0 34 34"
    sx={{ color: 'secondary.main', width: '34px', height: '34px' }}
    {...props}
  >
    <path d="M22.67 11.33H11.33v11.34h11.34V11.33Z" fill="#55A6FF" />
    <path
      d="M17 2.83a14.17 14.17 0 1 0 .01 28.35A14.17 14.17 0 0 0 17 2.83Zm0 25.5A11.35 11.35 0 0 1 5.67 17c0-6.25 5.08-11.33 11.33-11.33S28.33 10.75 28.33 17 23.25 28.33 17 28.33Z"
      fill="#55A6FF"
    />
  </SvgIcon>
)
